import { createFileRoute } from '@tanstack/react-router';

import { HelpDesk } from '../modules/HelpDesk';

export const Route = createFileRoute('/helpDesk')({
  component: HelpDesk,
});
